<template>
  <div>
    <f7-block-title v-html="$t('title.cardStatus.title', {status: $t(`title.cardStatus.${card.status}`)})"/>
    <div v-if="!isPending" class="aio-card">
      <img src="~@/assets/img/aio-card-template.svg" class="elevation-5">
      <div id="content">
        <div class="no">**** **** **** {{card.last4Digits | format4Digits}}</div>
        <div class="expiry">
          <div>{{$t('label.monthYear')}}</div>
          <p>{{$t('label.expiresEnd')}}</p>
          <span>{{card.expiry | formatExpiry}}</span>
        </div>
        <div class="currency">{{card.currency}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'aio-card',
    computed: {
      isPending () {
        return this.card.status === 'pending'
      }
    },
    filters: {
      format4Digits (last4Digits) {
        return ('000' + last4Digits).slice(-4)
      },
      formatExpiry (expiryDate) {
        return moment(expiryDate).format('MM/YY')
      }
    },
    props: {
      card: Object,
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .block-title /deep/ {
    text-align: center;
    text-transform: none !important;
    b {
      color: $cyan;
      text-transform: uppercase;
    }
  }

  .aio-card {
    height: 204px;
    width: 324px;
    margin: auto;

    img {
      border-radius: 13px;
    }

    #content {
      bottom: 105px;
      color: $white;
      left: 25px;
      position: relative;

      .no {
        font-family: courier;
        font-size: 23px;
      }

      .expiry {
        padding-left: 70px;
        div {
          font-size: 8px;
          margin-left: 69px;
        }
        p {
          display: inline-block;
          font-size: 8px;
          margin: 0 0 0 30px;
          width: 39px;
        }
        span {
          font-family: courier;
          font-size: 18px;
        }
      }

      .currency {
        font-family: courier;
        font-size: 16px;
      }
    }
  }
</style>
